import { createAuthClient as createBetterAuthClient } from 'better-auth/react'

export interface CreateAuthClientOptions {
    baseURL: string
    /** URLs of all apps for cross-app sign out */
    allAppURLs?: string[]
}

// Structural interface for the auth client members used across apps.
// Defined explicitly rather than derived from ReturnType to avoid TS2742 errors
// when emitting declarations (better-auth internals reference unresolvable .mjs paths).
export interface AuthClient {
    signIn: ReturnType<typeof createBetterAuthClient>['signIn']
    signUp: ReturnType<typeof createBetterAuthClient>['signUp']
    signOut: ReturnType<typeof createBetterAuthClient>['signOut']
    useSession: ReturnType<typeof createBetterAuthClient>['useSession']
    signOutAll: () => Promise<void>
}

export function createAuthClient(options: CreateAuthClientOptions): AuthClient {
    const client = createBetterAuthClient({
        baseURL: options.baseURL,
    })

    /**
     * Signs out from all configured apps
     */
    const signOutAll = async () => {
        const urls = options.allAppURLs ?? [options.baseURL]
        await Promise.all(
            urls.map((url) =>
                fetch(`${url}/api/auth/sign-out`, {
                    method: 'POST',
                    credentials: 'include',
                }).catch((err) => {
                    console.warn(`Failed to sign out from ${url}:`, err)
                })
            )
        )
    }

    // Return client with signOutAll added
    // We need to explicitly reference client properties since spread doesn't copy getters
    return Object.assign(client, { signOutAll })
}
